import React from 'react';
import {SvgIcon} from '@material-ui/core';

function SvgIconStyled (props) {
  const {viewBox, svg, fontSize,style} = props; 
  let Style = style?style:{};
  return (
    <SvgIcon 
      style={{fontSize:fontSize?fontSize:'2.2rem',...Style}} 
      component={svg} 
      shapeRendering='geometricPrecision' 
      viewBox={viewBox?viewBox:'0 0 600 600'} 
    />
  );
}

export default SvgIconStyled;
